import React, { useState } from "react";
import { Table } from "react-bootstrap";
import TableHeader from "../../../Component/TableHeader/TableHeader";
import Moment from "react-moment";
import Pagination from "../../../Component/Paginatation/Pagination";

const ConsultantMyPackagesTable = ({
  tableRef,
  onMouseDown,
  editorFullMode,
}) => {
  const transactions = [
    {
      _id: "1",
      packageName: "Lorem ipsum dolor sit",
      category: "packages type",
      price: 100,
      purchasedDateTime: "2024-04-25 10:30:00",
      expiryDateTime: "2024-03-20 10:30:00",
      status: "completed",
    },
    {
      _id: "2",
      packageName: "Lorem ipsum dolor sit",
      category: "packages type",
      price: 100,
      purchasedDateTime: "2024-04-25 10:30:00",
      expiryDateTime: "2024-03-20 10:30:00",
      status: "completed",
    },
    {
      _id: "3",
      packageName: "Lorem ipsum dolor sit",
      category: "packages type",
      price: 100,
      purchasedDateTime: "2024-04-25 10:30:00",
      expiryDateTime: "2024-03-20 10:30:00",
      status: "completed",
    },
    {
      _id: "4",
      packageName: "Lorem ipsum dolor sit",
      category: "packages type",
      price: 100,
      purchasedDateTime: "2024-04-25 10:30:00",
      expiryDateTime: "2024-03-20 10:30:00",
      status: "expired",
    },
    {
      _id: "5",
      packageName: "Lorem ipsum dolor sit",
      category: "packages type",
      price: 100,
      purchasedDateTime: "2024-04-25 10:30:00",
      expiryDateTime: "2024-03-20 10:30:00",
      status: "completed",
    },
    {
      _id: "6",
      packageName: "Lorem ipsum dolor sit",
      category: "packages type",
      price: 100,
      purchasedDateTime: "2024-04-25 10:30:00",
      expiryDateTime: "2024-03-20 10:30:00",
      status: "completed",
    },
    {
      _id: "7",
      packageName: "Lorem ipsum dolor sit",
      category: "packages type",
      price: 100,
      purchasedDateTime: "2024-04-25 10:30:00",
      expiryDateTime: "2024-03-20 10:30:00",
      status: "completed",
    },
    {
      _id: "8",
      packageName: "Lorem ipsum dolor sit",
      category: "packages type",
      price: 100,
      purchasedDateTime: "2024-04-25 10:30:00",
      expiryDateTime: "2024-03-20 10:30:00",
      status: "completed",
    },
    {
      _id: "9",
      packageName: "Lorem ipsum dolor sit",
      category: "packages type",
      price: 100,
      purchasedDateTime: "2024-04-25 10:30:00",
      expiryDateTime: "2024-03-20 10:30:00",
      status: "completed",
    },
    {
      _id: "10",
      packageName: "Lorem ipsum dolor sit",
      category: "packages type",
      price: 100,
      purchasedDateTime: "2024-04-25 10:30:00",
      expiryDateTime: "2024-03-20 10:30:00",
      status: "completed",
    },
    {
      _id: "11",
      packageName: "Lorem ipsum dolor sit",
      category: "packages type",
      price: 100,
      purchasedDateTime: "2024-04-25 10:30:00",
      expiryDateTime: "2024-03-20 10:30:00",
      status: "completed",
    },
  ];

  const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case "completed":
        return "green";
      case "expired":
        return "red";
      default:
        return "inherit";
    }
  };

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const result = transactions?.slice(startIndex, endIndex);
  const totalPage = Math.ceil(transactions?.length / itemsPerPage);

  return (
    <>
      <TableHeader FilterSection />
      <div
        className="table_content overflow-auto mx-2"
        style={{
          maxHeight: editorFullMode ? "calc(100vh - 140px)" : "",
        }}
      >
        <div className="table-container tableLibrarySection">
          <Table
            id="resizable-table"
            className="m-0  custom-table"
            ref={tableRef}
            bordered
            striped
          >
            <thead>
              <tr>
                <th
                  style={{ width: 40 }}
                  onMouseDown={(e) => onMouseDown(e, 0)}
                >
                  Sr.
                </th>
                <th onMouseDown={(e) => onMouseDown(e, 1)}>Package Name</th>
                <th onMouseDown={(e) => onMouseDown(e, 2)}>Category</th>
                <th onMouseDown={(e) => onMouseDown(e, 3)}>Price</th>
                <th onMouseDown={(e) => onMouseDown(e, 4)}>
                  Purchased Date and Time
                </th>
                <th onMouseDown={(e) => onMouseDown(e, 5)}>
                  Expiry Date and Time
                </th>
                <th onMouseDown={(e) => onMouseDown(e, 6)}>Status</th>
              </tr>
            </thead>
            <tbody>
              {result?.map((transaction, index) => (
                <tr key={index}>
                  <td>{startIndex + index + 1}</td>
                  <td>{transaction.packageName}</td>
                  <td>{transaction.category}</td>
                  <td>${transaction.price}</td>
                  <td>
                    <Moment format="DD MMM YYYY | HH:mm">
                      {transaction.purchasedDateTime}
                    </Moment>
                  </td>
                  <td>
                    <Moment format="DD MMM YYYY | HH:mm">
                      {transaction.expiryDateTime}
                    </Moment>
                  </td>
                  <td className="text-capitalize">
                    <div
                      style={{
                        color: getStatusColor(transaction.status),
                        fontWeight: 500,
                      }}
                    >
                      {transaction.status}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
      <div className="mx-2">
        <Pagination
          totalPage={totalPage}
          pageNumber={pageNumber}
          itemsPerPage={itemsPerPage}
          totalItems={transactions?.length}
          setPageNumber={setPageNumber}
          setItemsPerPage={setItemsPerPage}
        />
      </div>
    </>
  );
};

export default ConsultantMyPackagesTable;
